function croppName(str, len) {
    if (str.length <= len) {
        return str;
    }
    str = str.slice(0, len);
    // crop white space at the end of the string
    if (str.charAt(str.length - 1) === ' ') {
        str = str.slice(0, len - 1);
    }
    return str + ' ...';
}

function croppFileName(name, length, ellipsis = '***') {
    if (name.length <= length) {
        return name;
    }
    const lastIndexOf = name.lastIndexOf('.');
    const croppedName = [name.substr(0, lastIndexOf), name.substr(lastIndexOf)];
    croppedName[0] =
        croppedName[0].substr(0, length - ellipsis.length) + ellipsis;
    return croppedName.join('');
}

export { croppName, croppFileName };
